import ApisService from './index'
import { IBalanceOfdebtAdd, IBalanceOfdebtImport, IBalanceOfdebtUpdate } from '../interfaces/balanceOfdebtInterfaces'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'

export function createBalanceOfdebt(data: IBalanceOfdebtAdd) {
  try {
    return ApisService.post('/canbang-congno/create-canbang-congno', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function updateBalanceOfdebt(data: IBalanceOfdebtUpdate) {
  try {
    return ApisService.put('/canbang-congno/' + data.id + '/update-canbang-congno', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getDetailBalanceOfdebt(id: string) {
  try {
    return ApisService.get('/canbang-congno/' + id + '/get-chitiet-canbang-congno')
  } catch (err) {
    handleError(err)
    throw err
  }
}


export function getListBalanceOfdebt(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/canbang-congno/filter-canbang-congno', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteBalanceOfdebt(id: string) {
  try {
    return ApisService.delete('/canbang-congno/' + id + '/delete-canbang-congno')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteMultIBalanceOfdebt(idArr: Array<string>) {
  try {
    return ApisService.delete('/canbang-congno/bulk-delete-canbang-congno', { data: idArr })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function importBalanceOfdebt(data: Array<IBalanceOfdebtImport>) {
  try {
    return ApisService.post('/canbang-congno/import-canbang-congno', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}